import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export type TDialogTypeState = 'confirmAction' | 'datePicker' | 'receiptHistory' | 'userSettings' | 'uploadReceipt' | 'waitProgress' | null;

export interface ISelectedDialogState {
  value: TDialogTypeState;
};

const initialState: ISelectedDialogState = {
  value: null
};

export const dialogsSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    showDialog: (state: ISelectedDialogState, action: PayloadAction<TDialogTypeState>) => {
      state.value = action.payload;
    },
  },
});

export const { showDialog } = dialogsSlice.actions;
export const activeDialogState = (state: RootState) => state.dialog.value;

export default dialogsSlice.reducer;
